module.exports = __webpack_public_path__ + "static/media/IMG_573611.48e83f57.jpg";